/* eslint-disable */
//tslint:disable

import { IAgentBonusSchema } from './AgentBonusSchema';
import { IUtilitiesTermsSchema } from './UtilitiesTermsSchema';

export interface IBargainTermsSchema {
  /** Бонус агентам **/
  agentBonus?: IAgentBonusSchema | null;
  /** Комиссия от другого агента, %% **/
  agentFee?: number | null;
  /** Возможен торг **/
  bargainAllowed?: boolean | null;
  /** Условия торга **/
  bargainConditions?: string | null;
  /** Цена с учетом торга **/
  bargainPrice?: number | null;
  /** Комиссия от прямого клиента, %% **/
  clientFee?: number | null;
  /** Тип договора **/
  contractType?: EContractType | null;
  /** Валюта **/
  currency?: ECurrency | null;
  /** Залог собственнику **/
  deposit?: number | null;
  /** Арендные каникулы **/
  hasGracePeriod?: boolean | null;
  /** Включено в ставку **/
  includedOptions?: EIncludedOptions[] | null;
  /** Срок аренды **/
  leaseTermType?: ELeaseTermType | null;
  /** Тип аренды **/
  leaseType?: ELeaseType | null;
  /** Минимальный срок аренды, мес **/
  minLeaseTerm?: number | null;
  /** Ипотека **/
  mortgageAllowed?: boolean | null;
  /** Период оплаты **/
  paymentPeriod?: EPaymentPeriod | null;
  /** Предоплата **/
  prepayMonths?: number | null;
  /** Цена **/
  price?: number | null;
  /** Тип цены **/
  priceType?: EPriceType | null;
  /** Тип продажи **/
  saleType?: ESaleType | null;
  /** Обеспечительный платеж **/
  securityDeposit?: number | null;
  /** Состав съемщиков **/
  tenantsType?: ETenantsType | null;
  /** Коммунальные услуги **/
  utilitiesTerms?: IUtilitiesTermsSchema | null;
  /** НДС включен (deprecated) **/
  vatIncluded?: boolean | null;
  /** Сумма налога **/
  vatPrice?: number | null;
  /** НДС **/
  vatType?: EVatType | null;
}

export enum EContractType {
  /** Переуступка прав аренды **/
  LeaseAssignment = 'leaseAssignment',
  /** Продажа **/
  Sale = 'sale',
}
export enum ECurrency {
  /** € **/
  Eur = 'eur',
  /** руб. **/
  Rur = 'rur',
  /** $ **/
  Usd = 'usd',
}
export enum EIncludedOptions {
  /** Операционные расходы **/
  OperationalCosts = 'operationalCosts',
  /** Коммунальные платежи **/
  UtilityCharges = 'utilityCharges',
}
export enum ELeaseTermType {
  /** На несколько месяцев **/
  FewMonths = 'fewMonths',
  /** Длительный **/
  LongTerm = 'longTerm',
}
export enum ELeaseType {
  /** Прямая аренда **/
  Direct = 'direct',
  /** Договор совместной деятельности **/
  JointVenture = 'jointVenture',
  /** Субаренда **/
  Sublease = 'sublease',
}
export enum EPaymentPeriod {
  /** За год **/
  Annual = 'annual',
  /** За месяц **/
  Monthly = 'monthly',
}
export enum EPriceType {
  /** Цена за все **/
  All = 'all',
  /** Цена за гектар **/
  Hectare = 'hectare',
  /** Цена за сотку **/
  Sotka = 'sotka',
  /** Цена за квадратный метр **/
  SquareMeter = 'squareMeter',
}
export enum ESaleType {
  /** Альтернатива **/
  Alternative = 'alternative',
  /** Договор уступки права требования **/
  Dupt = 'dupt',
  /** Договор ЖСК **/
  Dzhsk = 'dzhsk',
  /** Свободная продажа **/
  Free = 'free',
  /** 214-ФЗ **/
  Fz214 = 'fz214',
  /** Договор инвестирования **/
  Investment = 'investment',
  /** Предварительный договор купли-продажи **/
  Pdkp = 'pdkp',
}
export enum ETenantsType {
  /** Любой **/
  Any = 'any',
  /** Семья **/
  Family = 'family',
  /** Женщина **/
  Female = 'female',
  /** Мужчина **/
  Male = 'male',
}
export enum EVatType {
  /** НДС включен **/
  Included = 'included',
  /** НДС не включен **/
  NotIncluded = 'notIncluded',
  /** УСН (упрощенная система налогообложения) **/
  Usn = 'usn',
}
